export default "__VITE_ASSET__CZnJnTBk__"